import type { PrintFormat } from "./printProducts";

// Where AOTD prints live. Printed QR codes point at /aotd/<number>?pst=<print>, which records
// the scan and lands here (AotdScanRedirect).

export const TODAY_PRINTS_PATH = "/art-of-the-day/today/prints";

/** Today's prints, opened on one format when given. */
export const todayPrintsPath = (format?: PrintFormat) => (format ? `${TODAY_PRINTS_PATH}?format=${format}` : TODAY_PRINTS_PATH);
